module.exports = __webpack_public_path__ + "static/media/exo-latin-300.d373cd80.woff";